import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountVisibility } from 'api/visibility';

export const visibilitySlice = createSlice({
  name: '@@VISIBILITY',
  initialState: {},
  reducers: {
    update: (
      _state,
      { payload: visibility }: PayloadAction<AccountVisibility>,
    ) => visibility,
  },
});
